<ngb-alert class="carousel-message" *ngIf="carouselMessages.length > 0" [type]="'success'" [dismissible]="false">
  <span *ngIf="carouselMessages[countNum]?.icon === 'new'">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 -960 960 960" fill="var(--secondary-active)">
      <path
        d="M120-160q-33 0-56.5-23.5T40-240v-480q0-33 23.5-56.5T120-800h720q33 0 56.5 23.5T920-720v480q0 33-23.5 56.5T840-160H120Zm0-80h720v-480H120v480Zm20-120h50v-140l102 140h48v-240h-50v140L190-600h-50v240Zm240 0h160v-50H440v-44h100v-50H440v-46h100v-50H380v240Zm240 0h160q17 0 28.5-11.5T820-400v-200h-50v180h-44v-140h-50v140h-46v-180h-50v200q0 17 11.5 28.5T620-360ZM120-240v-480 480Z"
      />
    </svg>
    <label class="default-font bold pl-1">New Feature: </label>
  </span>
  <span *ngIf="carouselMessages[countNum]?.icon === 'soon'">
    <svg class="mb-1" xmlns="http://www.w3.org/2000/svg" height="15px" width="15px" viewBox="0 0 640 640">
      <!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        fill="var(--secondary-active)"
        d="M160 64C142.3 64 128 78.3 128 96C128 113.7 142.3 128 160 128L160 139C160 181.4 176.9 222.1 206.9 252.1L274.8 320L206.9 387.9C176.9 417.9 160 458.6 160 501L160 512C142.3 512 128 526.3 128 544C128 561.7 142.3 576 160 576L480 576C497.7 576 512 561.7 512 544C512 526.3 497.7 512 480 512L480 501C480 458.6 463.1 417.9 433.1 387.9L365.2 320L433.1 252.1C463.1 222.1 480 181.4 480 139L480 128C497.7 128 512 113.7 512 96C512 78.3 497.7 64 480 64L160 64zM224 139L224 128L416 128L416 139C416 158 410.4 176.4 400 192L240 192C229.7 176.4 224 158 224 139zM240 448C243.5 442.7 247.6 437.7 252.1 433.1L320 365.2L387.9 433.1C392.5 437.7 396.5 442.7 400.1 448L240 448z"
      />
    </svg>
    <label class="default-font bold pl-1">Coming Soon: </label>
  </span>
  <span *ngIf="carouselMessages[countNum]?.icon === 'hint'">
    <svg class="mb-1" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="var(--secondary-active)">
      <path
        d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
      />
    </svg>
    <label class="default-font bold pl-1">Helpful Hint: </label>
  </span>
  <span
    *ngIf="carouselMessages[countNum]?.icon !== 'new' && carouselMessages[countNum]?.icon !== 'soon' && carouselMessages[countNum]?.icon !== 'hint'"
  >
    <svg xmlns="http://www.w3.org/2000/svg" height="15px" width="15px" viewBox="0 0 512 512">
      <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        fill="var(--secondary-active)"
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
      />
    </svg>
  </span>

  <span class="pl-1" [innerHtml]="carouselMessages[countNum]?.description"></span>
  <a
    [href]="carouselMessages[countNum]?.link"
    target="_blank"
    class="pl-1"
    id="{{ carouselMessages[countNum]?.title }}Link"
    title="{{ carouselMessages[countNum]?.title }}"
    >{{ carouselMessages[countNum]?.title }}
  </a>

  <span *ngIf="carouselMessages.length > 1" class="svg-inline-right default-pointer" (click)="changeInfoMessage()" title="Next announcement">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
      <path fill="var(--secondary-active)" d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
    </svg>
  </span>
</ngb-alert>
<nav class="navbar navbar-expand-sm navbar-light bg-light navbar-top-header justify-content-between">
  <span>
    <img src="../../assets/termhub-short-logo.png" alt="Termhub" width="20" title="TermHub" class="mobile-header" />
  </span>
  <div class="d-flex align-items-center justify-content-end">
    <span class="get-started d-flex">
      <span class="desktop-md pr-1">Looking for guides and more information?</span>See<a
        [routerLink]="['/resources']"
        id="resourcesLink"
        class="pl-1 pr-1"
        >Resources</a
      >
      and
      <a [routerLink]="['/terminologies']" id="terminologiesLink" class="pl-1 pr-1">Terminologies</a>
    </span>
    <div class="header-menu align-items-center">
      <app-user-notifications class="pt-t-1"></app-user-notifications>
      <app-user-menu></app-user-menu>
    </div>
    <div class="ham-icon">
      <button class="navbar-toggler ham-menu-icon" type="button" (click)="addClassToBodyForResponsiveMenu()" id="menuBtn">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  </div>
</nav>
<app-expiration-banner *ngIf="showAlert" [type]="alertType" [expirationDate]="userData.planExpiration" (closeAlert)="closeAlert()" />
